module.exports = __webpack_public_path__ + "images/rich_heading/home_appliance_furniture/home_appliance/icon_28f2224651bbbbc6fab925772af36a37.png";